<div class="container-fluid">
  <div class="col p-0">
    <div class="col-12 static-card">
      <bd-light-table #grid [gridData]="gridData || []" [fields]="fields" [actions]="actionItems" [addNewRow]=true
        [gridEditable]="true" [classTable]="'questionnaires'" (handlerData)="handlerData($event)"
        (addNewRowCallback)="addNew()" [pageInfo]="pageInfo"
        [defaultId]="defaultQuestionnaireID" [customButton]="customButton"
        [defaultColumnTable]="true">
      </bd-light-table>
    </div>
  </div>
</div>

<ng-template #editModal>
  <div class="mb-4 justify-content-between align-items-center p-0">
    <h5 class="modal-title">{{ 'ERROR_MESSAGES.CHECK.EDIT_QUESTIONNAIRE_TITLE' | translate }}</h5>
  </div>
  <div class="">
    <p class="check-text"> {{ 'ERROR_MESSAGES.CHECK.EDIT_QUESTIONNAIRE_CONFIRMATION' | translate }} </p>
    <div class="alert-message check-popup mb-4">
      <img class="warning-icon" src="assets/ph-bhp-layout/svg/icon-warning-check.svg">
      <div class="alert-message d-flex"> {{ 'ERROR_MESSAGES.CHECK.EDIT_QUESTIONNAIRE_MESSAGE' | translate }} </div>
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <div class="align-items-end d-flex">
      <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd separate-buttons">{{ translationKeys.Button.No |
        translate }}</button>
      <button (click)="navigateToQuestionnaireEditor(editDataItem.questionnaireID);modalRef.hide()" class="btn-bd-empty">{{ translationKeys.Button.Yes | translate
        }}</button>
    </div>
  </div>
</ng-template>

<ng-template #deleteModal>
  <div class="mb-4 justify-content-between align-items-center p-0">
    <h5 class="modal-title">{{ 'ERROR_MESSAGES.CHECK.DELETE_QUESTIONNAIRE_TITLE' | translate }}</h5>
  </div>
  <div class="">
    <p class="check-text"> {{ 'ERROR_MESSAGES.CHECK.DELETE_QUESTIONNAIRE_CONFIRMATION' | translate }} </p>
    <div class="alert-message check-popup mb-4" *ngIf="hasChecksInProgress">
      <img class="warning-icon" src="assets/ph-bhp-layout/svg/icon-warning-check.svg">
      <div class="alert-message d-flex"> {{ 'ERROR_MESSAGES.CHECK.DELETE_QUESTIONNAIRE_MESSAGE' | translate }} </div>
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <div class="align-items-end d-flex">
      <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd separate-buttons">{{ translationKeys.Button.No |
        translate }}</button>
      <button (click)="deleteQuestionnaireConfirmed(deleteDataItem);modalRef.hide()" class="btn-bd-empty">{{ translationKeys.Button.Yes | translate
        }}</button>
    </div>
  </div>
</ng-template>